import { render, staticRenderFns } from "./TableCard.vue?vue&type=template&id=ac5cf00c&scoped=true&"
import script from "./TableCard.vue?vue&type=script&lang=js&"
export * from "./TableCard.vue?vue&type=script&lang=js&"
import style0 from "./TableCard.vue?vue&type=style&index=0&id=ac5cf00c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5cf00c",
  null
  
)

export default component.exports